import Swiper from 'swiper'
import SwiperCore, {Scrollbar} from 'swiper/core'

SwiperCore.use([Scrollbar])

export default class SizeGuide {
  constructor(component) {
    this.dom = {
      $component: component,
      $tables: component.querySelectorAll('.js-sizeGuideContainer')
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$tables.forEach($table => this.initSlider($table))
  }

  initSlider(table) {
    const swiper = new Swiper(table, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      freeMode: true,
      scrollbar: {
        el: table.querySelector('.js-sizeGuideScrollbar')
      },
      breakpoints: {
        768: {
          allowTouchMove: false
        }
      }
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.SizeGuide = this
  }
}
